module.exports = __webpack_public_path__ + "assets/img/5.19a4145b.png";